/**
 * 时间选择器工具函数
 */

/**
 * 时间维度
 */
export type TimeDimension = 'day' | 'week' | 'month' | 'quarter';

/**
 * 时间范围
 */
export interface TimeRange {
  start: Date;
  end: Date;
  label: string;
}

/**
 * 判断两个日期是否相同
 */
export function isSameDate(date1: Date, date2: Date): boolean {
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
}

/**
 * 根据日期和维度获取时间范围
 */
export function getRangeFromDate(date: Date, dimension: TimeDimension): TimeRange {
  switch (dimension) {
    case 'day':
      return {
        start: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59),
        label: formatDate(date)
      };
    case 'week':
      const weekStart = new Date(date);
      weekStart.setDate(date.getDate() - (date.getDay() || 7) + 1);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      return {
        start: weekStart,
        end: weekEnd,
        label: `${formatDate(weekStart)} - ${formatDate(weekEnd)}`
      };
    case 'month':
      const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
      const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return {
        start: monthStart,
        end: monthEnd,
        label: `${date.getFullYear()}-${String(date.getMonth() + 1).length === 1 ? '0' + String(date.getMonth() + 1) : String(date.getMonth() + 1)}`
      };
    case 'quarter':
      const quarter = Math.floor(date.getMonth() / 3);
      const quarterStart = new Date(date.getFullYear(), quarter * 3, 1);
      const quarterEnd = new Date(date.getFullYear(), (quarter + 1) * 3, 0);
      return {
        start: quarterStart,
        end: quarterEnd,
        label: `${date.getFullYear()}Q${quarter + 1}`
      };
  }
}

/**
 * 格式化日期
 */
export function formatDate(date: Date): string {
  const month = String(date.getMonth() + 1);
  const day = String(date.getDate());
  return `${date.getFullYear()}-${month.length === 1 ? '0' + month : month}-${day.length === 1 ? '0' + day : day}`;
}

/**
 * 格式化日期
 */
export function formatDateWithCustomFormat(date: Date, format: string): string {
  const month = String(date.getMonth() + 1);
  const day = String(date.getDate());
  return format
    .replace('YYYY', String(date.getFullYear()))
    .replace('MM', month.length === 1 ? '0' + month : month)
    .replace('DD', day.length === 1 ? '0' + day : day);
}